import { Box } from '@mui/material';
import React from 'react';
import { StatusPointer, StatusPointerActive, StatusPointerComplete, StatusPointerLoading, OrderClosed } from '../../assets/images/icons';

const OrderStatusIcon = ({ status, childStatus, order }) => {
  return (
    <Box sx={{ marginRight: { xs: '22px', sm: '10px', md: '22px' }, height: 32 }}>
      {order.orderState > status && <StatusPointerComplete />}

      {order.orderState == status && (
        status == 1 && (
          (order.verification.statusId == 0 && <StatusPointerActive />) ||
          (order.verificationKYC && <StatusPointerActive />) ||
          (order.verification.statusId == 1 && <StatusPointerLoading />) ||
          (order.verification.statusId > 1 && <OrderClosed />)
        ) ||
        status == 2 && <StatusPointerActive /> ||
        status == 3 && (

          order.depositViewType?.value === 'CRYPT' ? (
            childStatus == 1 && (
              [7, 70].includes(order.paymentStatus.id) ? <StatusPointerLoading /> : <StatusPointerComplete />
            ) ||
            childStatus == 2 && (
              [71].includes(order.paymentStatus.id) ? <StatusPointerLoading /> : order.paymentStatus.id == 6 ? <StatusPointerComplete /> : <StatusPointer />
            ) || childStatus == 3 && (
              order.paymentStatus.id == 6 ? <StatusPointerLoading /> : <StatusPointer />
            )
          ) : ( // other payment ways
            childStatus == 1 && (
              [7, 70].includes(order.paymentStatus.id) ? <StatusPointerLoading /> : <StatusPointerComplete />
            ) ||
            childStatus == 2 && (
              order.paymentStatus.id == 6 ? <StatusPointerLoading /> : <StatusPointer />
            )
          )

        ) ||
        status == 4 && <OrderClosed />
      )}

      {order.orderState < status && <StatusPointer />}
    </Box>
  )
}

export default OrderStatusIcon